<template>
  <section class="ai-visibility-panel-section">
    <section-header
      :title="title"
      :subtitle="subtitle"
      :info-title="infoTitle"
    />
    <panel-card
      :class="cardClass"
      :padded="padded"
      :flush="flush"
    >
      <slot />
    </panel-card>
  </section>
</template>

<script>
import PanelCard from './PanelCard.vue'
import SectionHeader from './SectionHeader.vue'

export default {
  name: 'PanelSection',
  components: {
    PanelCard,
    SectionHeader,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
    infoTitle: {
      type: String,
      default: '',
    },
    padded: {
      type: Boolean,
      default: true,
    },
    flush: {
      type: Boolean,
      default: false,
    },
    cardClass: {
      type: [String, Array, Object],
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>

.ai-visibility-questions-panel__card,
.ai-visibility-citation-sources-panel__card{
  min-height: 380px;
}

.ai-visibility-panel-section {
  min-width: 0;
}
</style>
